import client, { endpoints } from '../api/client';
import { USERS_ADMIN } from '../constants/actionTypes';

const errMsg = (e) => e?.response?.data?.error || e?.message || 'Unknown error.';

export const fetchUsers = (params = {}) => async (dispatch) => {
  dispatch({ type: USERS_ADMIN.LIST_REQUEST });
  try {
    const { data } = await client.get(endpoints.users.list, { params });
    dispatch({ type: USERS_ADMIN.LIST_SUCCESS, payload: data });
  } catch (e) {
    dispatch({ type: USERS_ADMIN.LIST_FAILURE, payload: errMsg(e) });
  }
};
export const setUserRole = (id, role) => async (dispatch) => {
  try {
    const { data } = await client.put(endpoints.users.setRole(id), { role });
    dispatch({ type: USERS_ADMIN.UPDATE, payload: data.user });
    return { ok: true };
  } catch (e) { return { ok: false, error: errMsg(e) }; }
};
export const suspendUser = (id, suspended, reason) => async (dispatch) => {
  try {
    const { data } = await client.put(endpoints.users.suspend(id), { suspended, reason });
    dispatch({ type: USERS_ADMIN.UPDATE, payload: data.user });
    return { ok: true };
  } catch (e) { return { ok: false, error: errMsg(e) }; }
};
export const deleteUser = (id) => async (dispatch) => {
  try {
    await client.delete(endpoints.users.remove(id));
    dispatch({ type: USERS_ADMIN.REMOVE, payload: id });
    return { ok: true };
  } catch (e) { return { ok: false, error: errMsg(e) }; }
};
export const setUserCapabilities = (id, extra, denied) => async (dispatch) => {
  try {
    const { data } = await client.put(endpoints.users.capabilities(id), { extra, denied });
    dispatch({ type: USERS_ADMIN.UPDATE, payload: data.user });
    return { ok: true };
  } catch (e) { return { ok: false, error: errMsg(e) }; }
};
